import React, { useState, useEffect } from 'react';

function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 400) { // Button visible after scrolling down 300px
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    isVisible && (
      <button onClick={scrollToTop} style={{
        position: 'fixed',
        bottom: '20px',
        right: '10px',
        height: '50px',
        width: '50px',
        borderRadius: '50%',
        fontSize: '24px',
      }}>
        ↑
      </button>
    )
  );
}

export default ScrollToTopButton;
